<template>
  <div class="overlay"></div>
  <router-view v-slot="slotProps">
    <transition name="fade">
      <div>  
      <component :is="slotProps.Component"></component>
      </div>
    </transition>
  </router-view>
</template>

<script>
export default {
  data() {
    return {
      dropdownItem: [
        {
          title: "Logout",
          link: "#",
        },
      ],
    };
  },
};
</script>

<style>
.overlay {
  background: rgba(0, 0, 0, 0.4);
  position: fixed;
  height: 100vh;
  width: 100%;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  /* opacity: 0; */
  z-index: -1;
  transition: all 0.4s ease-in-out 0s;
  border-radius: 6px !important;
}
.ual-modal-content-description {
  display: none;
}
.ual-open-learnMoreButton,
.ual-close-learnMoreButton {
  display: none !important;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
.fade-enter-active {
  transition: opacity 0.3s ease-out;
}

.fade-leave-active {
  transition: opacity 0.3s ease-out;
}
.slide-enter-active,
.slide-leave-active {
  transition: all 0.75s ease-out;
}

.slide-enter-to {
  position: absolute;
  right: 0;
}

.slide-enter-from {
  position: absolute;
  right: -100%;
}

.slide-leave-to {
  position: absolute;
  left: -100%;
}

.slide-leave-from {
  position: absolute;
  left: 0;
}
</style>
